import { doc, runTransaction, serverTimestamp } from 'firebase/firestore'

const COLLECTION = 'freeAccountSend'
const SUMMARY_DOC_ID = '_summary'
const MAX_ENTRIES_PER_BATCH = 20

/**
 * Append one analytics row for a completed free (non-subscribed, no credits) email send.
 * Batches up to MAX_ENTRIES_PER_BATCH per document, then starts a new batch doc.
 * Also maintains _summary: grandTotal, currentBatchId, currentBatchCount, approxSummarySizeBytes.
 */
export async function appendFreeAccountSendLog(db, payload) {
  const summaryRef = doc(db, COLLECTION, SUMMARY_DOC_ID)

  await runTransaction(db, async (transaction) => {
    const summarySnap = await transaction.get(summaryRef)
    const s = summarySnap.exists() ? summarySnap.data() : {}
    const prevGrand = Number(s.grandTotal) || 0
    const grandTotal = prevGrand + 1

    let currentBatchId = s.currentBatchId || null
    let currentBatchCount = Number(s.currentBatchCount) || 0

    const needsNewBatch = !currentBatchId || currentBatchCount >= MAX_ENTRIES_PER_BATCH
    if (needsNewBatch) {
      currentBatchId = `batch_${grandTotal}_${Date.now()}`
    }

    const batchRef = doc(db, COLLECTION, currentBatchId)
    const batchSnap = needsNewBatch ? null : await transaction.get(batchRef)
    const prevEntries = !needsNewBatch && batchSnap?.exists() ? batchSnap.data().entries : null
    const entries = Array.isArray(prevEntries) ? [...prevEntries] : []

    const row = {
      seq: grandTotal,
      userId: payload.userId || '',
      email: payload.email || '',
      firstName: payload.firstName || '',
      lastName: payload.lastName || '',
      recipientCount: payload.recipientCount ?? 0,
      scopeTitle: payload.scopeTitle || '',
      loggedAtMs: Date.now(),
    }
    entries.push(row)

    const batchPayload = {
      entries,
      batchTotal: entries.length,
      approxDocumentSizeBytes: new TextEncoder().encode(JSON.stringify(entries)).length,
      updatedAt: serverTimestamp(),
    }

    const summaryPayload = {
      grandTotal,
      currentBatchId,
      currentBatchCount: entries.length,
      approxSummarySizeBytes: new TextEncoder().encode(
        JSON.stringify({ grandTotal, currentBatchId, currentBatchCount: entries.length }),
      ).length,
      updatedAt: serverTimestamp(),
    }

    transaction.set(batchRef, batchPayload, { merge: true })
    transaction.set(summaryRef, summaryPayload, { merge: true })
  })
}
